import React from "react";
import { Brand } from "../app";

import { Overview } from "../components";

const Home = () => <>{Brand === "litesport" && <Overview />}</>;

export default Home;
